import type { QueryError } from 'src/queries/network.utils'

export type PhysicalCardLifecycleErrorKind =
  | 'stale'
  | 'operationActive'
  | 'uncertain'
  | 'retryable'
  | 'unavailable'
  | 'rejected'
  | 'transport'

export const classifyPhysicalCardLifecycleError = (
  error: QueryError,
): PhysicalCardLifecycleErrorKind => {
  switch (error.errorCode) {
    case 'CARD-MGMT.29':
    case 'CARD-MGMT.17':
    case 'CARD-MGMT.14':
      return 'stale'
    case 'CARD-MGMT.7':
      return 'operationActive'
    case 'CARD-MGMT.13':
      return 'uncertain'
    case 'CARD-MGMT.11':
    case 'CARD-MGMT.15':
      return 'retryable'
    case 'CARD-MGMT.3':
    case 'CARD-MGMT.4':
    case 'CARD-MGMT.30':
    case 'CARD-MGMT.18':
    case 'CARD-MGMT.34':
      return 'unavailable'
    case 'CARD-MGMT.1':
    case 'CARD-MGMT.2':
    case 'CARD-MGMT.6':
    case 'CARD-MGMT.12':
      return 'rejected'
    default:
      return 'transport'
  }
}
